<template>
  <FileInput
    accept="image/*"
    @change="handleChange"
  >
    <slot />
  </FileInput>
</template>

<script>

import FileInput from '../FileInput'

export default {
  components: { FileInput },

  name: 'ImageInput',

  model: {
    name: 'value',
    event: 'change'
  },

  methods: {
    async handleChange (e) {
      const fileArray = Array.from(e.target.files)

      const files = await Promise.all(fileArray.map(this.read))

      if (this.$attrs.multiple) {
        this.$emit('change', files)
      } else {
        const [ file ] = files

        this.$emit('change', file)
      }
    },

    read (file) {
      return new Promise(
        function (resolve, reject) {
          const reader = new FileReader()

          reader.readAsDataURL(file)

          reader.onload = function () { resolve(reader.result) }

          reader.onerror = reject
        }
      )
    }
  }
}

</script>
